import UpdateUserForm from './UpdateUserForm';
export default UpdateUserForm;
